const mapping: Record<string, string> = {
  id: 'q=>q.Id',
}

export const mapSortPrintBarcodeItemsParam = (key: string) => mapping[key]
